import ConditionType from './ConditionType'

const GreaterThanOrEqualsCondition: ConditionType = {
  value: 'greater than or equals',
  label: 'Greater Than or Equal To',
  hasRHS: true,
}

export default GreaterThanOrEqualsCondition
